HTMLDocument.prototype.ready = new Promise(resolve => {
  if (document.readyState != "loading") {
    resolve();
  } else {
    document.addEventListener("DOMContentLoaded", () => resolve());
  }
});

Array.prototype.inGroups = function(n) {
  const result = [];
  const chunkSize = Math.ceil(this.length / n);
  for (let i = 0; i < n; i++) {
    result.push(this.slice(chunkSize * i, chunkSize * i + chunkSize));
  }

  return result;
};
